import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import addmangerApi from '../../services/Api/addManager'; // adjust path if needed

// Async thunk using your custom API wrapper
export const addExcutive = createAsyncThunk(
  'excutive/addExcutive',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await addmangerApi.addexcutive(payload);
      // console.log("response.data", response.data, payload)
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

export const getExcutiveList = createAsyncThunk(
  "excutive/getexcutiveinfo",
  async (_, { rejectWithValue }) => {
    try {
      // get hr_id from localStorage
      const hr_id = localStorage.getItem("hrId");

      const response = await addmangerApi.getexecutivelist({ hr_id });
      // console.log("response.data?.data", response.data.executives);
      return response.data.executives || []; // always return an array, even if empty
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const deactivateExecutive = createAsyncThunk(
  'excutive/deactivateExecutive',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await addmangerApi.deactivateExecutive(payload);
      // console.log("response.data",response.data,payload)
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);
const excutiveSlice = createSlice({
  name: 'excutive',
  initialState: {
    isloading: false,
    iserror: null,
    success: false,
    data: null,
    historyData: [],
  },
  reducers: {
    resetStatus: (state) => {
      state.isloading = false;
      state.iserror = null;
      state.success = false;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addExcutive.pending, (state) => {
        state.isloading = true;
        state.iserror = null;
        state.success = false;
      })
      .addCase(addExcutive.fulfilled, (state, action) => {
        state.isloading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(addExcutive.rejected, (state, action) => {
        state.isloading = false;
        state.iserror = action.payload;
        state.success = false;
      })
      .addCase(getExcutiveList.pending, (state) => {
        state.isloading = true;
      })
      .addCase(getExcutiveList.fulfilled, (state, action) => {
        state.isloading = false;
        state.historyData = action.payload; // This will hold the executive's historical info
      })
      .addCase(getExcutiveList.rejected, (state, action) => {
        state.isloading = false;
        state.iserror = action.payload;
      })
      .addCase(deactivateExecutive.pending, (state) => {
        state.isloading = true;
        state.iserror = null;
      })
      .addCase(deactivateExecutive.fulfilled, (state, action) => {
        state.isloading = false;
        state.success = true;
        const deletedId = action.meta.arg.executive_id; // 👈 pick executive_id
        state.historyData = state.historyData.filter(
          (executive) => executive.executive_id !== deletedId
        );
      })

      .addCase(deactivateExecutive.rejected, (state, action) => {
        state.isloading = false;
        state.iserror = action.payload;
        state.success = false;
      })

  },
});

export const { resetStatus } = excutiveSlice.actions;

export default excutiveSlice.reducer;
